import { action } from 'typesafe-actions';
import { ModalActionType } from './actionTypes';

export const openModal = (modalName: string, modalProps?) =>
  action(ModalActionType.OPEN_MODAL, {
    modalName,
    modalProps,
  });

export const closeModal = (modalName: string, modalProps?) =>
  action(ModalActionType.CLOSE_MODAL, {
    modalName,
    modalProps,
  });
